import { fileToWebpDataUrl } from "utils/helpers/imgFunctions/fileToWebpDataUrl";
import { fileToWebpFile } from "utils/helpers/imgFunctions/fileToWebpFile";
import type { QuillImageUploadFunction } from "../types";

export type ResolveEditorImageOptions = {
    webpQuality?: number;
    maxW?: number;
    maxH?: number;
    uploadImage?: QuillImageUploadFunction;
};

/**
 * Single pipeline for toolbar / paste / drop:
 * optimize → Cloudflare upload.
 * Data-URL only when no upload function is configured (local/demo mode).
 */
export const resolveEditorImageSrc = async (
    file: File,
    {
        webpQuality = 0.8,
        maxW = 1200,
        maxH = 1200,
        uploadImage,
    }: ResolveEditorImageOptions,
): Promise<string> => {
    if (typeof uploadImage === "function") {
        try {
            const optimized = await fileToWebpFile(file, webpQuality, maxW, maxH);
            const uploadedSrc = await uploadImage(optimized);
            if (uploadedSrc) return uploadedSrc;
            console.error("[Editor] image upload returned empty", {
                name: file?.name,
                type: file?.type,
                size: file?.size,
            });
        } catch (error) {
            console.error("[Editor] image upload failed", error);
        }
        // Do not fall back to data: — that is what looked like "Ctrl+V just inserts data".
        return "";
    }

    return fileToWebpDataUrl(file, webpQuality, maxW, maxH);
};
